module.exports = __webpack_public_path__ + "static/media/renovations.41945ca6.png";